import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
import { noticesModule } from './notices'
import {noticeSettingsModule} from './noticeSettings'
import { peoplesModule } from './peoples'
import { usersModule } from './users'
import { groupsModule } from './groups'
import { organizationsModule } from './organizations'
import { commentsModule } from './comments'
import { profilesModule } from './profiles'
import { okrsModule } from './okrs'
import { keyResultsModule } from './keyResults'
import { objectivesModule } from './objectives'
import { onesModule } from './ones'
import { rtfbsModule } from './rtfbs'
import { _metaModule } from './_meta'
import { latestAccessModule } from './latestAccess'
import { repositoryModule } from './repository'
const db = firebaseApp.database()

Vue.use(Vuex)

// これが使えない
// const currentUserId = (firebaseApp.auth().currentUser) ? firebaseApp.auth().currentUser.uid : null
// currentUser情報はrootStateに登録される
// plugins
// Vue生成時に実行される関数の集まり
const currentUserRef = (currentUserId) => { return db.ref('users/' + currentUserId) }

// readTime 既読時間取得用
const readTimesRef = (currentUserId) => { return db.ref('readTimes/' + currentUserId) }
const GET_READ_TIMES = 'GET_READ_TIMES'

const myplugins = store => {
  console.log('myplugins')
  firebaseApp.auth().onAuthStateChanged(function (user) {
    console.log('myplugins:onAuthStateChanged')
    if (user) {
      console.log('myplugins:onAuthStateChanged:user', user)
      store.dispatch(getterConstants.GET_USER_INFO, user.uid)
      store.dispatch(GET_READ_TIMES, user.uid)
      if (user.displayName) {
        // 本当はuserInfo.userNameで判定したいが，store.state.getCurrentUserInfoが空になってしまう
        store.dispatch('excuteBind', user.uid)
      }
    } else {
      // store.dispatch(destroySession)
      // store.dispatch('destroySession')
    }
  })
}

const store = new Vuex.Store({
  modules: {
    _meta: _metaModule,
    notices: noticesModule,
    peoples: peoplesModule,
    organizations: organizationsModule,
    users: usersModule,
    groups: groupsModule,
    comments: commentsModule,
    profiles: profilesModule,
    okrs: okrsModule,
    objectives: objectivesModule,
    keyResults: keyResultsModule,
    ones: onesModule,
    rtfbs: rtfbsModule,
    noticeSettings: noticeSettingsModule,
    latestAccess: latestAccessModule,
    repository: repositoryModule
  },
  state: {
    currentUserId: firebaseApp.auth().currentUser
      ? firebaseApp.auth().currentUser.uid
      : null,
    authUser: {},
    currentUser: {},
    readyForState: {},
    readTimes: {}
  },
  mutations: {
    ...firebaseMutations,
    destroySession (state) {
      console.log('destroySession::', state)
      // console.log(Object.keys(state))
      state.currentUserId = ''
      state.authUser = {}
      state.currentUser = {}
      state.objectives.objectives = {}
      state.keyResults.keyresults = {}
      state.objectives.draftsObjectives = {}
      state.keyResults.draftsKeyresults = {}
      state.objectives.currentObjectives = {}
      state.objectives.currentObjectiveId = {}
      state.keyResults.currentKeyresults = {}
      state.objectives.currentDraftsObjectives = {}
      state.keyResults.currentDraftsKeyresults = {}
      state.notices.currentNotices = {}
      state.ones.current1on1requests = {}
      state.ones.current1on1s = {}
      state.ones.current1on1sDate = {}
      state.ones.currentDrafts1on1s = {}
      state.ones.drafts1on1s = {}
      state.ones._1on1requests = {}
      state.ones._1on1s = {}
      state.ones._1on1sDate = {}
      console.log('destroyedSession::', state)
    },
    setUser (state, user) {
      console.log('setUser:mutations', user)
      state.authUser = user
      if (user) {
        state.currentUserId = user.uid
        console.log('Auth:1', user, location.herf)
      } else {
        state.currentUserId = null
        console.log('Auth:0', user, location.herf)
      }
    },
    onFocus (state) {
      let currentUserId = state.currentUserId
      console.log('currentUserId::', currentUserId)
      if (currentUserId) {
        const setCurrentTimestampRef = db.ref('latestAccess/' + currentUserId + '/timestamp')
        let currentTimestamp = new Date().getTime() / 1000
        setCurrentTimestampRef.set(currentTimestamp)
        console.log('currentTimestamp', currentTimestamp)
      } else {
        console.log('onFocus false')
      }
    }
  },
  actions: {
    destroySession (context) {
      context.commit('destroySession')
      // return new Promise((resolve, reject) => {
      //   // context.commit('destroySession')
      //   resolve(context.commit('destroySession'))
      // })
    },
    initUser (context) {
      firebaseApp.auth().onAuthStateChanged(function (user) {
        console.log('actions:initUser:onAuthStateChanged:', user)
        context.commit('setUser', user)
      })
    },
    setUser (context, user) {
      console.log('actions:setUser', user)
      context.commit('setUser', user)
    },
    onFocus (context) {
      console.log('store:actions:onFocus', context)
      context.commit('onFocus')
    },
    excuteBind (context, userId) {
      let dispatchHeader = ''
      console.log('excuteBind', context, userId)

      dispatchHeader = '_meta/'
      this.dispatch(dispatchHeader + getterConstants.GET_META_USERS_LIST)
      this.dispatch(dispatchHeader + getterConstants.GET_META_EMAILS_LIST)
      this.dispatch(dispatchHeader + getterConstants.GET_META_USER_EMAILS_LIST)

      dispatchHeader = 'users/'
      this.dispatch(dispatchHeader + getterConstants.GET_USERS)
      this.dispatch(dispatchHeader + getterConstants.GET_USER_NAME_KEY)

      dispatchHeader = 'groups/'
      this.dispatch(dispatchHeader + getterConstants.GET_GROUPS)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_GROUPS, userId)
      this.dispatch(dispatchHeader + getterConstants.GET_GROUP_NAME_KEY)

      dispatchHeader = 'organizations/'
      this.dispatch(dispatchHeader + getterConstants.GET_ORGANIZATION_NAME_KEY)

      dispatchHeader = 'keyResults/'
      this.dispatch(dispatchHeader + getterConstants.GET_KEYRESULTS)
      this.dispatch(dispatchHeader + getterConstants.GET_DRAFTS_KEYRESULTS)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_KEYRESULTS, userId)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_DRAFTS_KEYRESULTS, userId)

      dispatchHeader = 'objectives/'
      this.dispatch(dispatchHeader + getterConstants.GET_OBJECTIVES)
      this.dispatch(dispatchHeader + getterConstants.GET_DRAFTS_OBJECTIVES)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_OBJECTIVES, userId)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_DRAFTS_OBJECTIVES, userId)

      dispatchHeader = 'ones/'
      this.dispatch(dispatchHeader + getterConstants.GET_1ON1S)
      this.dispatch(dispatchHeader + getterConstants.GET_1ON1S_DATE)
      this.dispatch(dispatchHeader + getterConstants.GET_1ON1S_REQUESTS)
      this.dispatch(dispatchHeader + getterConstants.GET_DRAFTS_1ON1S)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_1ON1S, userId)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_1ON1S_DATE, userId)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_1ON1S_REQUESTS, userId)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_DRAFTS_1ON1S, userId)

      dispatchHeader = 'rtfbs/'
      this.dispatch(dispatchHeader + getterConstants.GET_RTFBS)
      this.dispatch(dispatchHeader + getterConstants.GET_DRAFTS_RTFBS)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_DRAFTS_RTFBS, userId)

      dispatchHeader = 'notices/'
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_NOTICES, userId)

      dispatchHeader = 'noticeSettings/'
      this.dispatch(dispatchHeader + getterConstants.GET_NOTICESETTINGS)
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_NOTICESETTINGS, userId)

      dispatchHeader = 'comments/'
      this.dispatch(dispatchHeader + getterConstants.GET_CURRENT_COMMENTS, userId)
      this.dispatch(dispatchHeader + getterConstants.GET_COMMENTS)
    },
    removeTermsFlag: firebaseAction((context) => {
      const currentUserId = context.state.currentUserId
      if (currentUserId) {
        const removeTermsFlagRef = db.ref('users/' + currentUserId + '/showTerms')
        removeTermsFlagRef.remove()
        console.log('remove removeTermsFlag::')
      } else {
        console.log('no currentUserId::')
      }
    }),
    removeTutorialFlag: firebaseAction((context) => {
      const currentUserId = context.state.currentUserId
      if (currentUserId) {
        const removeTutorialFlagRef = db.ref('users/' + currentUserId + '/showTutorial')
        removeTutorialFlagRef.remove()
        console.log('remove removeTutorialFlag::')
      } else {
        console.log('no currentUserId::')
      }
    }),
    setReadTime: firebaseAction((context, value) => {
      const currentUserId = context.state.currentUserId
      let setReadTimeRef
      switch (value.itemType) {
        case 'comments':
          setReadTimeRef = db.ref(
            'readTimes/' +
            currentUserId + '/' +
            value.itemType + '/' +
            value.targetType + '/' +
            value.targetOwner + '/' +
            value.targetId + '/' +
            value.itemId
          )
          setReadTimeRef.set(value.readTime)
          break
        case 'relations':
          setReadTimeRef = db.ref(
            'readTimes/' +
            currentUserId + '/' +
            value.itemType + '/' +
            value.targetType + '/' +
            value.targetOwner + '/' +
            value.targetId + '/' +
            value.relationKey
          )
          setReadTimeRef.set(value.readTime)
          break
        case 'likes':
          setReadTimeRef = db.ref(
            'readTimes/' +
            currentUserId + '/' +
            value.itemType + '/' +
            value.targetType + '/' +
            value.targetOwner + '/' +
            value.targetId + '/' +
            value.likeOwner
          )
          setReadTimeRef.set(value.readTime)
          break
        default:
          break
      }
    }),
    [getterConstants.GET_USER_INFO]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_USER_INFO', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentUser', currentUserRef(currentUserId), { wait: true })
    }),
    [GET_READ_TIMES]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      bindFirebaseRef('readTimes', readTimesRef(currentUserId), { wait: true })
    }),
    [getterConstants.SET_CURRENT_TIMESTAMP]: firebaseAction((context, value) => {
      const currentUserId = context.state.currentUserId
      // console.log('value', value)
      if (currentUserId) {
        const setCurrentTimestampRef = db.ref('latestAccess/' + currentUserId + '/timestamp')
        setCurrentTimestampRef.set(value)
        // console.log('set current Timestamp::', value)
      } else {
        // console.log('no set currenttimestamp::')
      }
    }),
    // keyresultはサーバー側で削除
    [getterConstants.REMOVE_ITEM]: firebaseAction((context, value) => {
      const currentUserId = context.state.currentUserId
      let removeItemRef
      // console.log('value', value)
      if (value.target === 'rtfbs' || value.target === 'groups') {
        removeItemRef = db.ref(value.target).child(value.id)
      } else if (value.target === 'keyresults') {
        const removeParentObjRef = db.ref('objectives/' + currentUserId + '/' + value.parentId + '/keyresults/' + value.id)
        removeParentObjRef.remove()
        removeItemRef = db
          .ref(value.target + '/' + currentUserId)
          .child(value.id)
      } else {
        removeItemRef = db
          .ref(value.target + '/' + currentUserId)
          .child(value.id)
      }
      removeItemRef.remove()
    })
  },
  getters: {
    getUserId: state => state.currentUserId,
    getCurrentUser: state => state.currentUser,
    getCurrentUserInfo: state => state.currentUser.userInfo
  },
  plugins: [myplugins]
})

export default store



// WEBPACK FOOTER //
// ./src/stores/store.js